import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

export const AllWalletHistory = createAsyncThunk(
  "admin/manage-wallet/get-all-wallet-history",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.ManageWalletHIstory.getAllWalletHistory}?name=${filter?.name ||
          ""}&uniq_id=${filter?.uniq_id || ""}&date=${filter?.date ||
          ""}&transaction_type_id=${filter?.transaction_type_id ||
          ""}&type_id=${filter?.type_id || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`
      );

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "manage-wallet",
  initialState: {
    all_wallet_history: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete

      .addCase(AllWalletHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllWalletHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_wallet_history = action.payload || {};
      })
      .addCase(AllWalletHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
